import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchQBRDocumentPartners } from 'partner360/services/qbr/fetchQBRDocumentPartners'

import { REQUEST_QBR_PARTNERS } from '../constants'

export const requestQbrDocumentPartners = createAsyncThunk(
  REQUEST_QBR_PARTNERS,
  fetchQBRDocumentPartners
)
